// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Poppins', 'Poppins Fallback', sans-serif","fontStyle":"normal"},"className":"__className_d92134","variable":"__variable_d92134"};